import { CREHANA_ROOT_URL } from "@crehana/constants";
export var MAIN_FOOTER_PAGE_KEY = 'main-footer';
export var COMPANY_LINKS = [{
  label: 'COMPANY_ABOUT',
  href: /*#__PURE__*/"".concat(CREHANA_ROOT_URL, "/sobre-nosotros/")
}, {
  label: 'COMPANY_CREHANA_FOR_BUSINESS',
  href: '/business/'
}, {
  label: 'COMMUNITY_STORIES',
  href: /*#__PURE__*/"".concat(CREHANA_ROOT_URL, "/historias/")
}, {
  label: 'COMPANY_HIRING',
  href: /*#__PURE__*/"".concat(CREHANA_ROOT_URL, "/trabaja-con-nosotros/")
}
// {
//   label: 'CONTACT_PHONE',
//   href: 'tel:(+51) 963-761-736',
//   // the CONTACT_PHONE key contains a br tag because it needs to be rendered in two lines (mexico laws)
//   renderLabelAsHtml: true,
// },
];

export function COMMUNITY_LINKS(countryPrefix) {
  return [countryPrefix === 'mx' ? {
    // Note: The label is not translated because it is a legal term in Mexico
    label: 'Avisos de privacidad',
    href: "".concat(CREHANA_ROOT_URL, "/legal/avisos-de-privacidad/mx/")
  } : {
    label: 'HELP_PRIVACY',
    href: "".concat(CREHANA_ROOT_URL, "/legal/politicas-de-privacidad/")
  }, {
    label: 'HELP_COOKIES',
    href: "".concat(CREHANA_ROOT_URL, "/legal/politica-de-cookies/")
  }, {
    label: 'HELP_ARCO',
    href: "".concat(CREHANA_ROOT_URL, "/legal/solicitud-arco/")
  }];
}
export var HELP_LINKS = function HELP_LINKS(countryPrefix) {
  var links = [{
    label: 'COMPANY_HELP_CENTER',
    href: 'https://ayuda.crehana.com'
  }, {
    label: 'HELP_TERMS',
    href: "".concat(CREHANA_ROOT_URL, "/legal/terminos-y-condiciones/")
  }];
  if (countryPrefix === 'mx') {
    links.push({
      label: 'HELP_CANCELLATION',
      href: "".concat(CREHANA_ROOT_URL, "/politica-cancelacion-mexico/")
    });
  }
  if (countryPrefix === 'pe') {
    links.push({
      label: 'HELP_CLAIMS_BOOK',
      href: "".concat(CREHANA_ROOT_URL, "/libro-reclamaciones/")
    });
  }
  return links;
};